// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__yCtlu","title":"Navbar_title__g3iRa","menu":"Navbar_menu__8DXrr","menuItems":"Navbar_menuItems__DVtYY","menuBtn":"Navbar_menuBtn__gTYaX"};